import { useMutation } from 'react-query'
import { api } from '../../../api'
import { type RequestPersistence } from '../../../../types/persistence/request-persistence'

const createRequest = async (data: RequestPersistence) => {
  const response = await api.post('/requests', data)
  return response.data
}

export const useRequestCreateMutation = () => {
  return useMutation({
    mutationFn (data: RequestPersistence) {
      return createRequest(data)
    }
  })
}
